<!-- eslint-disable -->
<template>

  <div class="card bg-white border-0 rounded-3 mb-4 shadow-sm">
    <div class="card-body p-0">

      <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 p-4">
        <!-- Navigation Links -->
        <h4>
          <strong> Cześć {{ user ? user.name : '' }} </strong>
        </h4>


        <!-- Recruiter Su Block -->
        <div v-if="userRole==='recruiter_su'">
          <p>Твоя выплата: <b>{{ userSalary }} zl.</b> всего часов: {{ userHours }}</p>
        </div>

        <!-- Recruiter Zl Block -->
        <div v-else-if="userRole==='recruiter_zl'">
          <p>Твои часы: {{ zlData.yourHours }} &nbsp;&nbsp; Оплата: {{ zlData.userSalary }} &nbsp;&nbsp; Часы
            кандидатов:
            {{ zlData.userHiredHours }} &nbsp;&nbsp; Бонус: {{ zlData.bonus }} &nbsp;&nbsp; <b>Зарплата:
              {{ zlData.totalSalary }}</b></p>
        </div>


        <!-- Filters and Add Candidate -->
        <div class="d-flex align-items-center gap-3">
          <select
              v-model="listQuery.year"
              class="form-select form-select-sm w-auto"
              @change="handleFilter"
              aria-label="Выберите год"
          >
            <option value="" disabled selected>Выберите год</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>

          <select
              v-model="listQuery.month"
              class="form-select form-select-sm w-auto"
              @change="handleFilter"
              aria-label="Выберите месяц"
          >
            <option value="" disabled selected>Выберите месяц</option>
            <option v-for="(month, index) in months" :key="index" :value="index + 1">
              {{ month.label }}
            </option>
          </select>

          <div
              class="btn btn-outline-primary py-2 px-3 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          >
            <span>Поиск</span>
          </div>
        </div>
      </div>

      <!-- Grand Admin / Manager / Coordinator Block -->
      <div
          v-if="userRole==='grand_admin' || userRole==='manager' || userRole === 'coordinator' || userRole === 'coordinator_main'">
        <div v-for="(project, coordinator) in list" :key="coordinator" class="card">
          <div v-if="userRole === 'grand_admin' || userRole === 'admin' || userRole === 'manager'">
            <h3><p>&nbsp; координатор: <b>{{ coordinator }}</b></p></h3>
          </div>

          <div v-for="(item, index1) in project" :key="index1" class="card bg-white border-0 rounded-3 mb-4">
            <b>
              <p>&nbsp; <b>{{ index1 }}</b>
                {{ item[0].position && item[0].position.vacancy ? item[0].position.vacancy.number : '' }}
              </p>
            </b>

            <!-- Desktop Table -->
            <div class="default-table-area style-two all-projects">
              <div class="table-responsive">
                <table class="table table-bordered table-striped- table-hover align-middle">
                  <thead class="table-light">
                  <tr>
                    <th>Кандидат</th>
                    <th>Работа от</th>
                    <th>Работа до</th>
                    <th>Часы</th>
                    <th v-if="userRole === 'grand_admin' || userRole === 'admin'">Рекрутер</th>
                    <th>Действия</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in item" :key="index">
                    <td>{{ row.name }}</td>
                    <td>{{ row.arrival_date }}</td>
                    <td>
                      <div v-if="row.actualization.length > 0">
                        <span v-if="row.actualization[0].end_date">{{
                            row.actualization[0].end_date.slice(0, 10)
                          }}</span>
                      </div>
                      <div v-else>
                        <input type="date" v-model="row.end_date" class="form-control">
                      </div>
                    </td>
                    <td>
                      <div v-if="row.actualization.length > 0">
                        {{ row.actualization[0].hours }}
                      </div>
                      <div v-else>
                        <input type="number" v-model.number="row.hours" placeholder="часы" class="form-control">
                      </div>
                    </td>
                    <td v-if="userRole === 'grand_admin' || userRole === 'admin'">
                      {{ row.recruiter ? row.recruiter.name : 'нет рекрутера' }}
                    </td>
                    <td class="justify-content-around">
                      <button v-if="row.actualization.length === 0" @click="handleConfirm(row)"
                              class="btn btn-primary btn-sm"
                              title="Сохранить">
                        Сохранить
                      </button>
                      <div v-if="userRole === 'grand_admin' || userRole === 'admin'">
                        <button v-if="row.actualization.length !== 0" @click="handleDecline(row.id)"
                                class="btn btn-warning btn-sm" title="Удалить">
                          Удалить
                        </button>
                      </div>
                      <div v-if="row.actualization.length > 0 && row.actualization[0].is_confirmed == 1">
                        <b> подтверждено </b>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
        <button @click="collectAllData" class="btn btn-primary btn-sm">Сохранить все часы</button>
      </div>

      <!-- Recruiter Su and Zl Block -->
      <div v-if="userRole==='recruiter_su' || userRole==='recruiter_zl'">
        <div v-for="(item, coordinator) in candidates_for_recruiters" :key="coordinator"
             class="card bg-white border-0 rounded-3 mb-4">
          <p>&nbsp; координатор: <b>{{ coordinator }}</b></p>

          <!-- Desktop Table -->
          <div class="default-table-area style-two all-projects">
            <div class="table-responsive">
              <table class="table table-bordered table-striped- table-hover align-middle">
                <thead class="table-light">
                <tr>
                  <th>Проект</th>
                  <th>Кандидат</th>
                  <th>Работа от</th>
                  <th>Работа до</th>
                  <th>Часы</th>
                  <th>Рекрутер</th>
                  <th>Действия</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, index) in item" :key="index">
                  <td>{{ row.position && row.position.vacancy ? row.position.vacancy.title : '-' }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.arrival_date }}</td>
                  <td>
                    <div v-if="row.actualization.length > 0 && row.actualization[0].end_date">
                      <span>{{ row.actualization[0].end_date.slice(0, 10) }}</span>
                    </div>
                  </td>
                  <td>
                    <div v-if="row.actualization.length > 0">
                      {{ row.actualization[0].hours }}
                    </div>
                  </td>
                  <td>{{ row.recruiter ? row.recruiter.name : 'нет рекрутера' }}</td>
                  <td class="justify-content-around">
                    <div v-if="row.actualization.length > 0 && row.actualization[0].is_confirmed == 0">
                      <button @click="handleConfirmByRecruiter(row.id)" class="btn btn-success btn-sm"
                              title="Подтвердить">
                        Подтвердить
                      </button>
                      <button @click="handleDecline(row.id)" class="btn btn-warning btn-sm" title="Отклонить">
                        Отклонить
                      </button>
                    </div>
                    <div v-if="row.actualization.length > 0 && row.actualization[0].is_confirmed == 1">
                      <b> подтверждено </b>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
import {
  fetchList,
  createActualization,
  deleteActualization,
  confirmActualization,
  confirmActualizationMultiple,
  sendMessage
} from '@/api/actualization';


export default {
  name: 'actualizationTable',
  data() {
    const currentDate = new Date();
    let previousMonth = currentDate.getMonth(); // 0-based
    let previousYear = currentDate.getFullYear();

    if (previousMonth === 0) { // If it's January
      previousMonth = 12; // Set to December
      previousYear -= 1; // Adjust the year
    }

    const previousMonthInt = previousMonth; // 1-based month
    const defaultPreviousMonthDate = new Date(previousYear, previousMonth - 1, 1); // Still 0-based for Date


    return {
      isMobile: false,
      downloadLoading: false,
      userRole: null,
      userSalary: 0,
      userHours: 0,
      user: null,
      zlData: 0,
      expandedRows: [],
      tableKey: 0,
      listLoading: true,
      dialogMessageVisible: false,
      dialogFormVisible: false,
      temp: {
        message: '',
        start_date: '01/05/2024',
        end_date: '01/05/2024',
      },
      list: null,
      listExport: null,
      candidates_for_recruiters: null,
      actualizations: null,
      total: 0,
      listQuery: {
        search: '',
        /*  year: new Date(),*/
        year: 2025,
        month: previousMonthInt
      },
      handleYearChange(selectedDate) {
        if (selectedDate) {
          // Ensure the year is set correctly by adding 1 day
          const adjustedDate = new Date(selectedDate);
          adjustedDate.setDate(adjustedDate.getDate() + 1);
          this.listQuery.year = adjustedDate;
        }
        this.handleFilter(); // Trigger any additional filtering logic
      },
      defaultPreviousMonthDate: defaultPreviousMonthDate,
      years: [
        2025,
        2024,
      ],
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      fields: [
        {label: 'Проект', name: 'project'},
      ],
    };
  },
  computed: {
    isAllowedToShow() {
      const today = new Date().getDate();
      return this.userRole === 'recruiter_su' && today >= 1 && today <= 10;
    }
  },
  created() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.matchMedia("(max-width: 767px)").matches;
      console.log(this.isMobile ? 'This is a mobile screen size.' : 'This is not a mobile screen size.');
    },
    handleFilter() {
      this.getList();
    },
    async getList() {
      this.listLoading = true;
      const data = await fetchList(this.listQuery);
      this.list = data.candidates;
      this.listExport = data.candidatesExport;
      this.candidates_for_recruiters = data.candidates_for_recruiters;
      this.userSalary = data.userSalary;
      this.userHours = data.userHours;
      this.zlData = data.zlData;
      this.actualizations = data.actualizations;
      this.userRole = data.userRole;
      this.user = data.user;
      //this.total = data.vacancies.total;
      this.listLoading = false;
    },
    /*   flattenCandidates(items) {
         const candidates = [];
         items.forEach((vacancy) => {
           vacancy.vacancy_candidates.forEach((position) => {
             position.candidates.forEach((candidate) => {
               const arrivalDate = new Date(candidate.arrival_date);
               const endDate = this.calculateEndDate(candidate.end_date); // Pass candidate's end_date if available

               const hours = this.calculateHours(arrivalDate, endDate);

               if (candidate.status === 'Работает') {
                 if (this.userRole === 'grand_admin' || userRole === 'admin'  || this.userRole === 'manager') {
                   candidates.push({
                     id: candidate.id,
                     vacancyTitle: vacancy.title,
                     name: candidate.name,
                     arrival_date: candidate.arrival_date,
                     end_date: candidate.end_date || '-', // Use '-' if end_date is not provided
                     hours: hours.toFixed(2), // Ensure hours is formatted to two decimal places
                     recruiter: candidate.recruiter ? candidate.recruiter.name : '',
                     status: candidate.status,
                   });
                 } else if (this.userRole === 'coordinator') {
                   candidates.push({
                     id: candidate.id,
                     vacancyTitle: vacancy.title,
                     name: candidate.name,
                     arrival_date: candidate.arrival_date,
                     end_date: candidate.end_date || '-', // Use '-' if end_date is not provided
                     hours: hours.toFixed(2), // Ensure hours is formatted to two decimal places
                     recruiter: candidate.recruiter ? candidate.recruiter.name : '',
                     status: candidate.status,
                   });
                 } else if (this.userRole === 'recruiter_su' || this.userRole === 'recruiter_zl') {
                   if (candidate.recruiter && candidate.recruiter_id === this.user.id) {
                     candidates.push({
                       id: candidate.id,
                       vacancyTitle: vacancy.title,
                       name: candidate.name,
                       arrival_date: candidate.arrival_date,
                       end_date: candidate.end_date || '-', // Use '-' if end_date is not provided
                       hours: hours.toFixed(2), // Ensure hours is formatted to two decimal places
                       recruiter: candidate.recruiter ? candidate.recruiter.name : '',
                       status: candidate.status,
                     });
                   }
                 }
               }
             });
           });
         });
         return candidates;
       },*/
    calculateHours(arrivalDate, endDate) {
      const millisecondsPerDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
      const daysDifference = Math.round((endDate - arrivalDate) / millisecondsPerDay);
      let hours = daysDifference;
      if (daysDifference > 30) {
        hours = hours - 30;
      }
      //const hours = daysDifference * 8;
      return hours * 8;
    },
    calculateEndDate(endDate = null) {
      if (endDate) {
        return new Date(endDate); // Return the provided endDate as a Date object
      } else {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();

        // Calculate the last day of the current month
        const lastDayOfMonth = new Date(year, month + 1, 0);

        return lastDayOfMonth;
      }
    },
    sendMessage() {
      sendMessage(this.temp).then(() => {
        this.dialogMessageVisible = false;
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Отправлено',
        //   type: 'success',
        //   duration: 2000,
        // });
      });
    },
    toggleRowExpansion(index) {
      const position = this.expandedRows.indexOf(index);
      if (position === -1) {
        this.expandedRows.push(index); // Expand if not already expanded
      } else {
        this.expandedRows.splice(position, 1); // Collapse if already expanded
      }
    },
    handleView(candidate, vacancy) {
      this.temp.candidate = Object.assign({}, candidate);
      this.temp.vacancy = vacancy;
      this.dialogStatus = 'view';
      this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs['dataForm'].clearValidate();
      // });
    },
    createData() {
      createActualization(this.temp).then(() => {
        this.dialogFormVisible = false;
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        window.location.reload();
      });
    },
    isCandidateInActualizations(candidateId) {
      return this.actualizations.some(actualization => actualization.candidate_id === candidateId);
    },
    disabledDate(date) {
      // Get the start and end of the current month
      const start = new Date();
      start.setDate(1);
      start.setHours(0, 0, 0, 0);

      const end = new Date(start.getFullYear(), start.getMonth() + 1, 0, 23, 59, 59, 999);
      console.log('Date:', date, 'Start:', start, 'End:', end); // Debugging

      // Disable dates outside the current month
      return date < start || date > end;
    },
    handleConfirm(row) {
      const dataToSend = {
        candidate_id: row.id,
        end_date: row.end_date,
        hours: row.hours
      }
      createActualization(dataToSend).then(() => {
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        window.location.reload();
      });
    },
    handleDecline(item) {
      const dataToSend = {
        candidate_id: item,
      }
      deleteActualization(dataToSend).then(() => {
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        window.location.reload();
      });
    },
    handleConfirmByRecruiter(row) {
      const dataToSend = {
        candidate_id: row,
      }
      confirmActualization(dataToSend).then(() => {
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        window.location.reload();
      });
    },
    collectAllData() {
      const allData = [];

      for (const coordinator in this.list) {
        const project = this.list[coordinator];
        for (const index1 in project) {
          const candidates = project[index1];
          candidates.forEach(candidate => {
            allData.push({
              candidate_id: candidate.id,
              end_date: candidate.end_date,
              hours: candidate.hours
            });
          });
        }
      }
      confirmActualizationMultiple(allData).then(() => {
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        window.location.reload();
      });
    },
    handleDownload() {
      this.downloadLoading = true;
      /*      import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['Номер проекта', 'Координатор', 'Кандидат', 'Работает от', 'Работает до', 'Часы', 'Рекрутер'];
              const filterVal = ['position.vacancy.number', 'position.vacancy.coordinator.name', 'name', 'arrival_date', 'actualization[0].end_date', 'actualization[0].hours', 'recruiter.name'];
              const list = this.listExport;
              const data = this.formatJson(filterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: 'candidates',
                autoWidth: this.autoWidth,
                bookType: this.bookType,
              });
              this.downloadLoading = false;
            });*/
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(item =>
          filterVal.map(path => this.getNestedValue(item, path))
      );
    },

    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, part) => {
        if (part.includes('[')) {
          // Handle array index
          const arrayPart = part.split('[');
          const prop = arrayPart[0];
          const index = parseInt(arrayPart[1].replace(']', ''), 10);
          return acc && acc[prop] && acc[prop][index];
        }
        return acc && acc[part];
      }, obj);
    }
  },
};
</script>
<!-- eslint-enable -->

<style scoped>
.app-container {
  margin-top: 50px;
}

.filter-container, .filter-container-mobile {
  margin-bottom: 20px;
}

.filter-item {
  margin: 5px;
  width: auto;
}

.filter-item-mobile {
  width: 100%;
  margin-bottom: 10px;
}

.mobile-table {
  display: flex;
  flex-direction: column;
}

.mobile-table-row {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.card {
  padding: 10px;
}

.table-wrapper {
  margin-top: 10px;
}

.save-all-btn {
  margin-top: 20px;
}

.card {
  margin-bottom: 20px;
}

td {
  min-width: 200px;
  text-align: left;
}

th {
  min-width: 200px;
  text-align: left;
}
</style>